/* eslint-disable no-underscore-dangle */
import { useState, useEffect, useContext } from 'react';

import { useMutation } from '@apollo/client';

import { GeneralContext } from '../../../../core/app-context/GeneralContext';
import { UPDATE_USER } from './graphql';
import { USER_FIELDS } from '../use-user-form/userFormFields';

export function useUpdateUser() {
  const { setLoading, setErrorMessage, setSuccessMessage } =
    useContext(GeneralContext);
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [UpdateUser, { loading: apiLoading }] = useMutation(UPDATE_USER, {
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    setIsLoading(apiLoading);
    setLoading(apiLoading);
  }, [apiLoading]);

  async function updateUser({ id, user }) {
    setIsSuccess(false);
    try {
      const res = await UpdateUser({
        variables: {
          user: {
            firstName: user[USER_FIELDS.NAME],
            lastName: user[USER_FIELDS.LAST_NAME],
            keycloakUserId: id,
          },
        },
      });
      if (res.data.updateUser.code === 201) {
        setIsSuccess(true);
        setSuccessMessage(res.data.updateUser.message);
      } else {
        setErrorMessage(res.data.updateUser.message);
      }
    } catch (e) {
      setErrorMessage('Algo deu errado, tente novamente mais tarde.');
    }
  }

  return {
    updateUser,
    loading: isLoading,
    success: isSuccess,
  };
}
